<script setup>
defineProps({
  headline_1: String,
  headline_2: String,
});

defineBuilderComponent({
    friendlyName: 'Footer',
    ignored: true
})
</script>

<template>
  <footer
    class="p-4 border-t-2 bg-lifeboost-blue-dark md:p-6 border-t-gray-400"
  >
    <div
      class="relative flex flex-wrap items-center justify-between px-5 mx-auto max-w-screen-2xl md:px-7 lg:px-14 xl:px-20 2xl:px-12"
    >
      <div
        class="flex flex-wrap items-center justify-center w-full mb-6 text-xs lg:w-auto lg:justify-start lg:text-sm lg:mb-0 md:space-x-12"
      >
        <a
          href="https://lifeboostcoffee.com/pages/contact-us-2"
          class="block w-1/2 text-center text-white md:w-auto hover:text-lifeboost-red"
          >Contact us</a
        ><a
          href="https://lifeboostcoffee.com/pages/privacy"
          class="block w-1/2 text-center text-white md:w-auto hover:text-lifeboost-red"
          >Privacy Policy</a
        ><a
          href="https://lifeboostcoffee.com/pages/terms"
          class="block w-1/2 text-center text-white md:w-auto hover:text-lifeboost-red sm-max:mt-6"
          >Terms &amp; Conditions</a
        >
      </div>
      <div
        class="flex flex-wrap items-center justify-center w-full space-x-3 text-sm lg:w-auto lg:justify-end"
      >
        <p class="block w-full mb-3 text-center text-white md:w-auto md:mb-0">
          © Lifeboost Group Inc. {{ new Date().getFullYear() }}
        </p>
      </div>
    </div>
  </footer>
</template>

<style>
.zls-1 {
  color: #fff;
  fill: #fff;
}
</style>
